/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

var extensions = [
	require("./extensions/bushfire-assessment.js").default
];

var promise;
function load() {
	if(!promise) {
		promise = Promise.all(extensions.map(function(e) {
			return e.load ? e.load() : Promise.resolve(true);
		})).then(() => extensions);
	}
	return promise;
}

export default load;
